<template>
    <div class="side">
        <div role="tablist">
            <b-card no-body class="mb-1">
            <b-card-header header-tag="header" role="tab" style="padding: 0; border: none; border-radius: 0;">
                <b-button block v-b-toggle.accordion-1 class="side-title" style="border: none;">
                    物件を絞り込む
                </b-button>
            </b-card-header>
            <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
                <b-card-body>
                    <div class="condition-body">
                        <div class="condition-inner">

                            <div class="condition-item">
                                <div class="item-title">新着物件</div>
                                <div class="item-setting">
                                    <input class="form-control" type="date" v-model="options.newlyFrom" id="example-date-input">
                                    <span>〜</span>
                                    <input class="form-control" type="date" v-model="options.newlyTo" id="example-date-input">
                                </div>
                            </div>

                            <div class="condition-item">
                                <div class="item-title">価格</div>
                                <div class="item-setting">
                                    <el-select v-model="options.priceFrom" placeholder="価格下限">
                                        <el-option
                                        v-for="price in priceList"
                                        :key="price.key"
                                        :label="priceLabel(price, 'min')"
                                        :value="price.id">
                                        </el-option>
                                    </el-select>
                                    <span>〜</span>
                                    <el-select v-model="options.priceTo" placeholder="価格上限">
                                        <el-option
                                        v-for="price in priceList"
                                        :key="price.key"
                                        :label="priceLabel(price, 'max')"
                                        :value="price.id">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>

                            <div class="condition-item">
                                <div class="item-title">土地面積</div>
                                <div class="item-setting">
                                    <el-select v-model="options.landAreaFrom" placeholder="土地面積下限">
                                        <el-option
                                        v-for="area in landAreaList"
                                        :key="area.id"
                                        :label="area.value"
                                        :value="area.id">
                                        </el-option>
                                    </el-select>
                                    <span>〜</span>
                                    <el-select v-model="options.landAreaTo" placeholder="土地面積上限">
                                        <el-option
                                        v-for="area in landAreaList"
                                        :key="area.id"
                                        :label="area.value"
                                        :value="area.id">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>

                            <div class="condition-item">
                                <div class="item-title">一種単価</div>
                                <div class="item-setting">
                                    <el-select v-model="options.unitPriceFrom" placeholder="価格上限">
                                        <el-option
                                        v-for="price in unitPriceList"
                                        :key="price.key"
                                        :label="priceLabel(price, 'min')"
                                        :value="price.id">
                                        </el-option>
                                    </el-select>
                                    <span>〜</span>
                                    <el-select v-model="options.unitPriceTo" placeholder="価格上限">
                                        <el-option
                                        v-for="price in unitPriceList"
                                        :key="price.key"
                                        :label="priceLabel(price, 'max')"
                                        :value="price.id">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>

                            <div class="condition-item">
                                <div class="item-title area-flex">
                                    <span>エリア - 23区</span>
                                    <button @click="allCheck" type="button" class="btn btn-outline-secondary btn-sm" style="font-size: 80%">{{ allCheckTitle }}</button>
                                </div>
                                <div class="item-setting container" style="padding: 0;">
                                    <div class="row">
                                        <div class="col-6" v-for="(city, index) in wardsOfTokyo" :key="index">
                                            <label>
                                                <!-- TODO: 名前で送っているが数が増えてきたらIDで渡すようにする -->
                                                <input type="checkbox" :value="city.value" v-model="options.area"> {{ city.value }}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="condition-item">
                                <div class="item-title">駅距離</div>
                                <div class="item-setting">
                                    <el-select v-model="options.stationDistance" placeholder="駅距離">
                                        <el-option
                                        v-for="stationDistance in stationDistanceList"
                                        :label="stationDistance.value"
                                        :key="stationDistance.id"
                                        :value="stationDistance.id">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>

                            <div class="condition-item" style="border: none;">
                                <div class="item-title">容積率</div>
                                <div class="item-setting">
                                    <el-select v-model="options.floorAreaRatioFrom" placeholder="容積率下限">
                                        <el-option
                                            v-for="floorAreaRatio in floorAreaRatioList"
                                            :key="floorAreaRatio.id"
                                            :label="priceLabel(floorAreaRatio, 'min')"
                                            :value="floorAreaRatio.id">
                                        </el-option>
                                    </el-select>
                                    <span>~</span>
                                    <el-select v-model="options.floorAreaRatioTo" placeholder="容積率上限">
                                        <el-option
                                            v-for="floorAreaRatio in floorAreaRatioList"
                                            :key="floorAreaRatio.id"
                                            :label="priceLabel(floorAreaRatio, 'max')"
                                            :value="floorAreaRatio.id">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>

                            <div style="text-align: center; padding: 2rem 0;">
                                <button @click="search" class='search-btn'>この条件で絞り込み</button>
                            </div>

                        </div>
                    </div>
                </b-card-body>
            </b-collapse>
            </b-card>
        </div>
    </div>
</template>

<script>
import { wardsOfTokyo } from '../../definitions/search/wards_of_tokyo'
import { stationDistanceList } from '../../definitions/search/station_distance_list'
import { priceList } from '../../definitions/search/price_list'
import { floorAreaRatioList } from '../../definitions/search/floor_area_ratio_list'
import { unitPriceList } from '../../definitions/search/unit_price_list'
import { landAreaList } from '../../definitions/search/land_area_list'

export default {
    data() {
        return {
            options: {
                newlyFrom: '',
                newlyTo: '',
                priceFrom: 0,
                priceTo: 0,
                landAreaFrom: 0,
                landAreaTo: 0,
                unitPriceFrom: 0,
                unitPriceTo: 0,
                area: [],
                stationDistance: 0,
                floorAreaRatioFrom: 0,
                floorAreaRatioTo: 0
            }
        }
    },
    mounted() {
        this.init()
        this.handleResize()
    },
    computed: {
        wardsOfTokyo() {
            return wardsOfTokyo;
        },
        stationDistanceList() {
            return stationDistanceList
        },
        priceList() {
            return priceList
        },
        floorAreaRatioList() {
            return floorAreaRatioList
        },
        isAllSelected() {
            return this.options.area.length === this.wardsOfTokyo.length
        },
        allCheckTitle() {
            return this.isAllSelected ? '全て解除' : '全て選択'
        },
        unitPriceList() {
            return unitPriceList
        },
        landAreaList() {
            return landAreaList
        }
    },
    methods: {
        init() {
            this.options.newlyTo = this.$moment(new Date).format('YYYY-MM-DD')
        },
        handleResize() {
            let width = window.innerWidth

            if (width <= 1000) {
                const accordion = document.getElementById('accordion-1')
                accordion.style.display = 'none'
            }
        },
        search() {
            this.$emit('search', this.options)
        },
        // 全て選択ボタン
        allCheck() {

            // 選択されていない場合は、全部追加
            if (!this.isAllSelected) {
                this.options.area = []

                this.wardsOfTokyo.forEach((element) => {
                    this.options.area.push(element.value)
                })

                return
            }

            // 全て選択されている場合は、全部消す
            this.options.area = []
        },
        // 下限と上限の選択肢用に表示を修正する
        priceLabel(price, range) {
            if (price === null) {
                return ''
            }

            if (price.id === 0) {
                return price.value
            }

            return range == 'min' ? price.value + '以上' : price.value + '以下'
        }
    }
}
</script>

<style scoped>

    /*-------------side-------------------*/
    .side {
        width: 300px;
    }

    .side-title {
        background-color: #F7B62D;
        font-size: 14px;
        font-weight: bold;
        color: white;
        padding: 1rem;
        width: 100%;
        margin: 0;
    }

    .side-title:hover {
        background-color: #F7B62D;
    }

    .side-title:focus {
        background-color: #F7B62D;
    }

    .item-title {
        font-weight: bold;
        font-size: 13px;
        margin-bottom: 5px;
    }

    .condition-title {
        height: 50px;
    }

    /*-------------condition-------------------*/
    .condition-inner {
        padding: 10px;
    }

    .condition-item {
      padding: 15px 30px 30px 10px;
      font-size: 12px;
      text-align: left;
    }

    .condition-item:not(:last-child) {
        border-bottom: 0.5px solid #D0D0D0;
    }

    .item-setting {
      margin-top: 10px;
    }

    /* 2カラムコンテンツにする */

    .archive {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
    }

    .archive div {
        margin-bottom: 3rem;
        width: 35%;
        background-color: #f0f0f0;
    }

    .archive img {
        display: block;
        margin-bottom: 3rem;
        width: 100%;
        height: auto;
    }

    .area-flex {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    /*-------------button-------------------*/
    .search-btn {
        width: 90%;
        height: 50px;
        background-color: #F7B62D;
        border: none;
        color: white;
    }

    .search-btn:hover {
        background-color: #FAAB03;
    }
</style>